import { io } from 'socket.io-client';
import { ENABLE_SOCKET_IO, REST_API_IO } from 'src/constants/Defaultvalues';

const noop = () => {};

/** Safe stand-in so callers can keep using on/off/emit/disconnect without connecting. */
export function createNoopSocket() {
  return {
    on: noop,
    off: noop,
    once: noop,
    emit: noop,
    disconnect: noop,
    connect: noop,
    removeListener: noop,
    removeAllListeners: noop,
    connected: false,
    disconnected: true,
    id: null,
  };
}

/**
 * App-wide Socket.IO factory.
 * When ENABLE_SOCKET_IO is false, returns a no-op socket (no network, no console errors).
 *
 * To restore old direct usage later, uncomment the `io(...)` lines left in each consumer file, e.g.:
 *   socketRef.current = io(REST_API_IO, { path: "/socket.io", transports: ["websocket", "polling"], secure: true });
 * Or simply set ENABLE_SOCKET_IO = true in Defaultvalues.js.
 */
export default function createAppSocket(options = {}) {
  if (!ENABLE_SOCKET_IO || !REST_API_IO) {
    return createNoopSocket();
  }

  // Same options as the previous direct io(REST_API_IO, ...) calls
  return io(REST_API_IO, {
    path: '/socket.io',
    transports: ['websocket', 'polling'],
    secure: true,
    reconnection: true,
    ...options,
  });
}
